const apikey = {
    SERVICE:'service_1ze59lg',
    USER_ID: 'user_KmWQvK32vEjLeYY3HI3mJ',
    RESERVATION_TEMPLATE: 'template_pu24wrd'
}

export default apikey

